import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Table from "react-bootstrap/Table";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";

const RangeLoanRecovery = () => {
  const { rangeId } = useParams();
  const [vfcList, setVfcList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const [summary, setSummary] = useState({});
  const LOCAL_KEY = `rangeLoanDataCache_${rangeId}`;
  const [selectedLoanType, setSelectedLoanType] = useState("Department Loan");

  const saveToLocalCache = (data, summary) => {
    const cache = {
      data,
      summary,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(LOCAL_KEY, JSON.stringify(cache));
  };

  const loadFromLocalCache = () => {
    const raw = localStorage.getItem(LOCAL_KEY);
    return raw ? JSON.parse(raw) : null;
  };

  const fetchData = async () => {
    const config = Authorization();
    try {
      const res = await axios.get(
        `${Api}/api/drill/loan/by-range/${rangeId}`,
        config
      );
      setVfcList(res.data.data);
      saveToLocalCache(res.data.data, res.data.summary);
      setSummary(res.data.summary);
    } catch (error) {
      console.error("Failed to load VFCs", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached?.data) {
      setVfcList(cached.data);
      setSummary(cached.summary || {});
      setLoading(false);
    } else {
      fetchData();
    }
  }, [rangeId]);
  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };
  const formatAmount = (amount) => {
    if (amount >= 10000000) {
      return (amount / 10000000).toFixed(2) + " Cr"; // Crores
    } else if (amount >= 100000) {
      return (amount / 100000).toFixed(2) + " L"; // Lakhs
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(2) + " K"; // Thousands
    }
    return amount; // Return as is if less than 1000
  };
  if (loading) return <Preloader loading={true} />;
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => {
            localStorage.removeItem(LOCAL_KEY);
            setLoading(true);
            fetchData();
          }}
        >
          🔄 Refresh Now
        </button>

        <div className="text-muted small">
          Last Refreshed:{" "}
          {loadFromLocalCache()?.timestamp
            ? formatDateTime(loadFromLocalCache().timestamp)
            : "Not Available"}
        </div>
      </div>

      <div className="card bg-gradient-CoolSky card-img-holder text-white">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />
          <h4 className="font-weight-normal mb-3">
            {vfcList.length > 0 ? vfcList[0].rangeName : "Loading..."} Range -
            Deaprtment Loan
          </h4>
          <h3>
            Loan Amount Recovered -{" "}
            {formatAmount(summary?.totalDepartmentRecoveredAmount || 0)}
          </h3>
        </div>
      </div>

      {/* Table */}
      <div className="mt-3">
        <Table striped bordered hover className="text-center">
          <thead>
            <tr>
              <th>#</th>
              <th>VFC</th>
              <th>Male Beneficiaries</th>
              <th>Female Beneficiaries</th>
              <th>Third Gender Beneficiaries</th>
              <th>Amount Disbursed</th>
            </tr>
          </thead>
          <tbody>
            {vfcList
              .sort((a, b) => a.vfcName.localeCompare(b.vfcName))
              .map((vfc, index) => (
                <tr key={vfc.vfcId}>
                  <td>{index + 1}</td>
                  <td
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate(`/drill/vfc-recovery/${vfc.vfcId}`)}
                  >
                    {vfc.vfcName}
                  </td>

                  <>
                    <td>{vfc.departmentLoan.male}</td>
                    <td>{vfc.departmentLoan.female}</td>
                    <td>{vfc.departmentLoan.others}</td>
                    <td>{vfc.departmentLoanAmount.toLocaleString("en-IN")}</td>
                  </>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default RangeLoanRecovery;
